import React from "react";
import Navbar from "./Navbar";
import HeroSection from "./HeroSection";
import AboutTrust from "./AboutTrust";
import AboutGarudaSena from "./AboutGarudaSena";
import WhyJoin from "./WhyJoin";
import Footer from "./Footer";
import Gallery from "./Gallery";
import FeedbackSection from "./FeedbackSection";
import ScrollingBanner from "./ScrollingBanner";


const HomePage = () => {
  return (
    <>
      <Navbar />
      <HeroSection />
      <AboutTrust />
      <AboutGarudaSena />
      <Gallery/>
      <WhyJoin />
      <FeedbackSection/>
          <ScrollingBanner/>
      <Footer />
    </>
  );
};

export default HomePage;
